export const BRAND_COLOR = '#001c57';
export const DARK_COLOR = '#0e0e0e';
export const LIGHT_COLOR = '#fff';
export const GRAY_COLOR = '#8c8c8c';
